import Grid2 from "@mui/material/Grid2";

import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { TableCampaign } from "./components/TableCampaign";
import {
	CampaignDelayResponse,
	CampaignResponse,
} from "./models/CampaignReponse";
import {
	getCampaignDelays,
	getCampaigns,
} from "./repositories/CampaignRepository";

type useCampaignsProps = {
	onError: (error: Error) => void;
	campaignId?: number;
	start?: Date;
	end?: Date;
};

export const useCampaigns = ({
	campaignId,
	start,
	end,
	onError,
}: useCampaignsProps) => {
	return useQuery<CampaignResponse[], Error>({
		queryKey: ["campaigns", campaignId, start?.getTime(), end?.getTime()],
		queryFn: ({ signal }) => getCampaigns({ campaignId, start, end }, signal),
		onError: onError,
		refetchInterval: 60_000,
	});
};

export const useCampaignDelays = ({
	start,
	end,
	onError,
}: useCampaignsProps) => {
	return useQuery<CampaignDelayResponse[], Error>({
		queryKey: ["campaignDelays", start?.getTime(), end?.getTime()],
		queryFn: ({ signal }) => getCampaignDelays({ start, end }, signal),
		refetchInterval: 60_000,
		onError: onError,
	});
};

export const CampaignPage = () => {
	const { campaignId } = useParams();

	return (
		<>
			<HelmetDexteel title="Mill Schedule" />
			<Grid2 container justifyContent="center" alignItems="center">
				<Grid2 size={{ md: 12, xs: 12 }} style={{ margin: 0 }}>
					<TableCampaign campaignId={campaignId} />
				</Grid2>
			</Grid2>
		</>
	);
};
